import React from 'react'
import { useTrans } from 'hooks'
import { Page, ProdottiCorrelati } from 'components/organisms'
import { WContainer, WImage, Button } from 'components/atoms'
import { CantinaVideo, CantinaInfo, CantinaStoria } from 'components/molecules'
import Head from 'next/head'

import { Vector3, Vector6 } from 'components/atoms/Icons'
import CantinaContatti from 'components/organisms/CantinaContatti/CantinaContatti'

interface Props {
  className?: string
  cantina: any
  pagina
}

const CantinaTemplate = (props: Props) => {
  const { className = '', cantina, pagina } = props

  const t = useTrans()

  const prodottiCorrelati = (cantina) => {
    return cantina.prodotti.edges.slice(0, 4).map((node) => ({
      ...node.node,
    }))
  }

  return (
    <Page
      item={cantina}
      pagina={pagina}
      className="cantina-template"
      childrenContainerVariant="none"
    >
      <Head>
        <link rel="preload" as="image" href={cantina.mainImage.image} />
      </Head>
      <div className="cantina-template__vector-center">
        <Vector3 />
      </div>
      <div className="cantina-template__vector-right">
        <Vector6 />
      </div>
      <div className="cantina-template__head">
        <div className="cantina-template__bg__clip">
          <div
            className="cantina-template__bg__image"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%), url(${cantina.mainImage.image})`,
            }}
          />
        </div>
      </div>
      <div className="cantina-template__logo">
        <WImage
          src={cantina.logoTrasparente?.image}
          maxWidth={120}
          maxHeight={120}
          className="cantina-template__logo__img"
          alt={cantina.titolo}
          title={cantina.titolo}
          loading='eager'
        />
      </div>
      <WContainer>
        <p className="cantina-template__title">{cantina.titolo}</p>
        <div
          className="cantina-template__subtitle"
          dangerouslySetInnerHTML={{ __html: cantina.sottotitolo }}
        ></div>
        <div className="cantina-template__content">
          <CantinaVideo
            cantina={cantina}
            className="cantina-template__video"
          />
          <CantinaInfo cantina={cantina} className="cantina-template__info" />
          <CantinaStoria cantina={cantina} className="cantina-template__storia" />
          {cantina.prodotti.edges.length > 0 && (
            <ProdottiCorrelati
              prodotti={prodottiCorrelati(cantina)}
              title={t('{0} prodotti di questa cantina', [cantina.numeroProdotti])}
              className="cantina-template__prodotti"
            />
          )}
          {cantina.numeroProdotti > 4 && (
            <div className="cantina-template__more">
              <Button
                label={t('Vedi tutti i prodotti')}
                variant="secondary"
                className="cantina-template__more-button"
                href={`/i-vini/cantina/${cantina.slug}`}
              />
            </div>
          )}
          <CantinaContatti cantina={cantina} className="cantina-template__contatti" />
        </div>
      </WContainer>
    </Page>
  )
}

export default CantinaTemplate
